import { RefObject, useLayoutEffect, useRef } from 'react';

import { useReferralInfo } from '@flipster/features/src/shared/referral-code/state';
import { isServer } from '@flipster/utils/env-helper';
import segment, { ReferralEvent } from '@flipster/utils/segment';

import { useSocialLogin } from '@web/hooks/useSocialLogin';

import { ensureGoogleSignInInitialized, setGoogleSignInCallback, useGoogleSignInReady } from './google-sign-in';

export const checkInAppBrowser = () => {
  if (isServer) return false;
  const agent = navigator.userAgent.toLowerCase();
  return /kakao|instagram|fb|trill/i.test(agent);
};

export const useGoogleSignInButton = (containerRef: RefObject<HTMLDivElement | null>) => {
  const ready = useGoogleSignInReady();
  const loginHandler = useSocialLogin();
  const referralInfo = useReferralInfo();
  const referralInfoRef = useRef(referralInfo);
  referralInfoRef.current = referralInfo;
  const isInAppBrowser = checkInAppBrowser();

  useLayoutEffect(() => {
    if (!ready || isInAppBrowser || !containerRef.current) return;

    setGoogleSignInCallback((credential) => loginHandler('GOOGLE', credential));
    ensureGoogleSignInInitialized();

    const container = containerRef.current;
    container.innerHTML = '';
    window.google?.accounts.id.renderButton(container, {
      size: 'large',
      width: container.offsetWidth + 'px',
      click_listener() {
        segment.track(ReferralEvent.SignInSsoClick, {
          auth_type: 'google',
          ...referralInfoRef.current,
        });
      },
    });
  }, [ready, isInAppBrowser, loginHandler, containerRef]);

  return { ready, isInAppBrowser };
};
